import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove the static SEO tags from index.html (marked data-rh="true").
// Non-JS crawlers see them in the raw HTML; once the app boots,
// react-helmet-async provides per-route tags and these would be stale duplicates.
document.querySelectorAll('[data-rh="true"]').forEach((el) => el.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
